import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    open: false,
    networkNavOpen: false,
    activeLevel: 0,
    activeLevel0Item: null as string | null,
    activeLevel1Item: null as string | null,
    activeLevel2Item: null as string | null,
    height: 0,
  }),
  getters: {
    getOpen: state => state.open,
    getNetworkNavOpen: state => state.networkNavOpen,
    getActiveLevel: state => state.activeLevel,
    getActiveLevel0Item: state => state.activeLevel0Item,
    getActiveLevel1Item: state => state.activeLevel1Item,
    getActiveLevel2Item: state => state.activeLevel2Item,
    getHeight: state => state.height,
  },
  actions: {
    reset() {
      this.activeLevel = 0
      this.networkNavOpen = false
      this.activeLevel0Item = null
      this.activeLevel1Item = null
      this.activeLevel2Item = null
    },
    setOpenState(open: boolean) {
      this.open = open
    },
    toggle() {
      this.open = !this.open
    },
    setNetworkNavOpenState(open: boolean) {
      this.networkNavOpen = open
    },
    toggleNetworkNavOpen() {
      this.networkNavOpen = !this.networkNavOpen
    },
    setActiveLevel(level: number) {
      this.activeLevel = level
    },
    setActiveLevel0Item(item: string | null) {
      this.activeLevel0Item = item
    },
    setActiveLevel1Item(subItem: string | null) {
      this.activeLevel1Item = subItem
    },
    setActiveLevel2Item(subItem: string | null) {
      this.activeLevel2Item = subItem
    },
    setHeight(height: number) {
      this.height = height
    },
  },
})
